export const chartColors = [
    "#E43E9F",
    "#5DC6FF",
    "#7C9EFF",
    "#D549CD",
    "#2A4971",
];

export const titleCase = (s: string): string =>
    s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const orderWithUnknownLast = (cats: string[]): string[] => {
    const rest = cats.filter((c) => c !== "unknown");
    const unk = cats.filter((c) => c === "unknown");
    return [...rest, ...unk];
};
